import { useLocation, useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, message } from "antd";
import { setCookie } from "../../utils/cookie";
import logo from "../../assets/logo.jpg";
import headLogo from "../../assets/logo.jpg";
import studioLogo from "../../assets/newStudioLogo.png";
import "./index.css";
import { wexonlogin } from "../../api/api";
import { useEffect } from "react";

export default function Login() {
  let navigate = useNavigate();
  let location = useLocation();
  console.log(location);
  let from =
    location?.state?.from?.pathname === "/"
      ? "/homepage"
      : location.state?.from?.pathname;

  console.log(from);

  const onFinish = (e) => {
    // console.log('success',from)
    //向后端请求登录验证
    wexonlogin(e).then((res) => {
      // console.log(res.data.code);
      if (res.data.code === 0) {
        //登录成功后记录信息
        let Info = res.data.data;
        let time = new Date(Info.last_login_time + "");
        console.log(Info);
        console.log("登录成功！");
        localStorage.setItem("username", Info.username);
        localStorage.setItem("Authorization", Info.access_token);
        localStorage.setItem("last_login", time.getTime());
        localStorage.setItem("refresh_token", Info.refresh_token);
        localStorage.setItem("authority", Info.authority);
        console.log("from", from);
        from
          ? navigate(from, { replace: true, state: { from: from } })
          : navigate("/homepage");
      } else if (res.data.code === 1010) {
        message.error("用户名或密码错误！");
      }
    });
    // console.log('form-data:',e);
  };

  return (
    <div className="login">
      <img className="loginLogo" src={headLogo} alt="logo" />
      <img className="rightsideLogo" src={logo} alt="logo" />
      <div className="loginBox">
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: "请输入账号!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="请输入账号"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "请输入密码!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="请输入密码"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="footer">
        <img className="studioLogo " src={studioLogo} alt="studioLogo" />
      </div>
    </div>
  );
}
